import { ABTestProviderConfig, IABTestProvider } from "../types";
import { VWOProvider } from "./VWOProvider";
import { AmplitudeProvider } from "./AmplitudeProvider";

export class ABTestProviderFactory {
  static createProvider(providerConfig: ABTestProviderConfig): IABTestProvider {
    if (!providerConfig.enabled) {
      throw new Error(`AB Test Provider "${providerConfig.provider}" is disabled`);
    }

    switch (providerConfig.provider) {
      case "vwo":
        return new VWOProvider(providerConfig.config);

      case "amplitude":
        return new AmplitudeProvider(providerConfig.config);

      default:
        throw new Error(`Unsupported AB Test Provider: ${providerConfig.provider}`);
    }
  }
}
